/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createSkillRequestSchema = z.object({
  isCritical: z.boolean().nullish(),
  name: z.string().min(1),
});
